export default {
  userInfo: {},
  access_token: "",
  expire_in: 0,
  refresh_token: "",
  showChangePwd: false
};
